import React from "react";
import { LanguageChanger } from "../dashboard/Layout";
import { useTranslation } from "react-i18next";
import { useDashboardLanguage } from "../../../hooks/useDashboardLanguage";

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  const { i18n } = useTranslation();
  useDashboardLanguage();

  return (
    <div className="auth-layout bg-gray-100 ">
      <div className="w-full h-[72px] py-4 bg-gray-700 justify-center items-center inline-flex">
        <img
          src={"https://cdn.1cdn.app/application/UMD/24042216091381_Logo.svg"}
          alt="Logo"
          className="w-[280px]"
        />
      </div>
      <div className="w-full min-h-[calc(100vh-135px)] px-8 pt-12 pb-2 flex-col justify-center items-center gap-8 inline-flex">
        {children}
      </div>
      <div className="flex justify-center items-center gap-8 py-4">
        <LanguageChanger i18n={i18n} className="bg-gray-400" />
      </div>
    </div>
  );
};

export default AuthLayout;
